import { CSSProperties, FormEvent, MouseEventHandler } from "react";

interface ButtonProps {
  hasText?: boolean;
  text?: string;
  onClick:
    | (() => void)
    | ((e: FormEvent<HTMLFormElement>) => void)
    | MouseEventHandler;
  hasImage?: boolean;
  image?: string;
  disabled?: boolean;
  className?: string;
  type?: "button" | "submit" | "reset";
  style?: CSSProperties;
  id?: string;
  imgStyle?: CSSProperties;
  textStyle?: CSSProperties;
  alt?: string;
}

export const Button = ({
  hasImage,
  image,
  hasText,
  text,
  onClick,
  disabled,
  className,
  type,
  style,
  id,
  imgStyle,
  textStyle,
  alt,
}: ButtonProps) => (
  <button
    onClick={onClick as MouseEventHandler}
    disabled={disabled}
    className={className}
    type={type}
    style={style}
    id={id}
  >
    {hasImage && (
      <img
        alt={alt}
        src={image}
        style={
          imgStyle ?? {
            height: "5vh",
            borderRadius: 3,
          }
        }
      />
    )}
    {hasText && <p style={textStyle}>{text}</p>}
  </button>
);
